<template>
  <div :class="['pc-icon']" :title="title" @click="clickHandler">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  methods: {
    clickHandler (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .15s linear, color .15s linear;
  border-radius: 50%;

  svg {
    display: inline-block;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }
}

.pc-icon:not(.static):hover {
  cursor: pointer;
  color: $color-main;
  background: rgb(217, 236, 255);
}
</style>
